// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as CSS$Showside from "./CSS.bs.js";
import * as QuickViewButton$Showside from "../components/QuickViewButton.bs.js";
function Stack(Props) {
  var maxThumbnails = Props.maxThumbnails;
  var items = Props.items;
  var isVisibleOpt = Props.isVisible;
  var directionOpt = Props.direction;
  var spacingOpt = Props.spacing;
  var widthOpt = Props.width;
  var offsetLeftOpt = Props.offsetLeft;
  var offsetRightOpt = Props.offsetRight;
  var offsetBottomOpt = Props.offsetBottom;
  var heightOpt = Props.height;
  var rotationOpt = Props.rotation;
  var isVisible = isVisibleOpt !== undefined ? isVisibleOpt : true;
  var direction = directionOpt !== undefined ? directionOpt : /* Vertical */0;
  var spacing = spacingOpt !== undefined ? spacingOpt : 8;
  var width = widthOpt !== undefined ? widthOpt : 0;
  var offsetLeft = offsetLeftOpt !== undefined ? offsetLeftOpt : 0;
  var offsetRight = offsetRightOpt !== undefined ? offsetRightOpt : 0;
  var offsetBottom = offsetBottomOpt !== undefined ? offsetBottomOpt : 0;
  var height = heightOpt !== undefined ? heightOpt : 0;
  var rotation = rotationOpt !== undefined ? rotationOpt : /* Positive */1;
  var match = React.useState(function () {
    return false;
  });
  var setThumbnailsMouseOver = match[1];
  var thumbnailsMouseOver = match[0];
  var total = items.length;
  var thumbnails = Belt_Array.mapWithIndex(items, function (index, param) {
    var id = param[0];
    var render = param[1];
    var onClick = param[2];
    var tilt = index - (total - (4 < maxThumbnails ? 4 : maxThumbnails) | 0) | 0;
    var x;
    if (thumbnailsMouseOver) {
      switch (direction) {
        case /* Vertical */0:
          x = 0;
          break;
        case /* Horizontal */1:
          x = Math.imul(index, width + spacing | 0);
          break;
        case /* Fan */2:
          x = (tilt > 0 ? tilt : 0) << 1;
          break;
      }
    } else {
      x = (tilt > 0 ? tilt : 0) << 1;
    }
    var x$1 = String(x + spacing | 0);
    var y;
    if (thumbnailsMouseOver) {
      switch (direction) {
        case /* Vertical */0:
          y = Math.imul(index, height + spacing | 0);
          break;
        case /* Horizontal */1:
          y = 0;
          break;
        case /* Fan */2:
          y = Math.imul(tilt > 0 ? tilt : 0, 3);
          break;
      }
    } else {
      y = Math.imul(tilt > 0 ? tilt : 0, 3);
    }
    var y$1 = String(y + spacing | 0);
    var angle = thumbnailsMouseOver ? direction >= 2 ? Math.imul(tilt > 0 ? tilt : 0, 7) : 0 : Math.imul(tilt > 0 ? tilt : 0, 5);
    var angle$1 = String(rotation ? angle : -angle | 0);
    var className = CSS$Showside.prefix(Cn.make(["relative transition-shadow duration-500 bg-white", thumbnailsMouseOver || tilt >= 0 ? "shadow" : ""]));
    return React.createElement("div", {
      key: id,
      className: CSS$Showside.prefix("absolute transition-transform duration-200 pointer-events-auto"),
      style: {
        transform: "translate(" + x$1 + "px, " + y$1 + "px) rotate(" + angle$1 + "deg)"
      }
    }, React.createElement(QuickViewButton$Showside.make, {
      onClick: function (e) {
        e.stopPropagation();
        e.preventDefault();
        Curry._1(onClick, undefined);
      },
      children: React.createElement("div", {
        className: className
      }, Curry._1(render, undefined))
    }));
  });
  return React.createElement("div", {
    className: CSS$Showside.prefix("relative"),
    style: {
      left: CSS$Showside.intToPx(offsetLeft)
    }
  }, React.createElement("div", {
    className: CSS$Showside.prefix("relative"),
    style: {
      right: CSS$Showside.intToPx(offsetRight)
    }
  }, React.createElement("div", {
    className: CSS$Showside.prefix("relative"),
    style: {
      bottom: CSS$Showside.intToPx(offsetBottom)
    }
  }, React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["transition-opacity duration-200", isVisible ? "opacity-100" : "opacity-0"])),
    onMouseEnter: function (param) {
      Curry._1(setThumbnailsMouseOver, function (param) {
        return true;
      });
    },
    onMouseLeave: function (param) {
      Curry._1(setThumbnailsMouseOver, function (param) {
        return false;
      });
    }
  }, thumbnails))));
}
Stack.displayName = "Stack";
var make = Stack;
export { make };
/* react Not a pure module */